import actionTypes from 'Redux/constants';

import ProTierService from 'services/proTier';

export const setShowGoProPopup = show => ({
  type: actionTypes.pro.setShowGoProPopup,
  payload: show,
});

export const setShowProWelcomeOverlay = show => ({
  type: actionTypes.pro.setShowProWelcomeOverlay,
  payload: show,
});

export const setSubscriptionLoading = loading => ({
  type: actionTypes.pro.setSubscriptionLoading,
  payload: loading,
});

export const setSubscriptionInfo = subscriptionInfo => ({
  type: actionTypes.pro.setSubscriptionInfo,
  payload: subscriptionInfo,
});

export const fetchSubscriptionInfo = () => async dispatch => {
  try {
    dispatch(setSubscriptionLoading(true));
    const response = await ProTierService.getSubscriptionInfo();

    dispatch(setSubscriptionInfo({
      currentPlan: response.current_plan,
      hasConsumedFreeTrial: response.has_consumed_free_trial,
      canManageBilling: response.can_manage_billing,
    }));
  }
  catch (error) {
    console.error('Failed to fetch subscription info:', error);
    dispatch(setSubscriptionLoading(false));
  }
};
